import { render, staticRenderFns } from "./ScrollStrip.vue?vue&type=template&id=bfb211a4&scoped=true&"
import script from "./ScrollStrip.vue?vue&type=script&lang=js&"
export * from "./ScrollStrip.vue?vue&type=script&lang=js&"
import style0 from "./ScrollStrip.vue?vue&type=style&index=0&id=bfb211a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb211a4",
  null
  
)

export default component.exports